export const specialties = [
  "General Dentist",
  "Anesthesiologist",
  "Consultant",
  "Cosmetic Dentist",
  "Dental Assistant",
  "Dental Company Rep",
  "Dental Educator",
  "Dental Lab Tech",
  "Dental Student",
  "Dental Hygiene Student",
  "Dental Resident",
  "Endodontist",
  "Endodontic Resident",
  "Front Office Coordinator",
  "Hygienist",
  "Implantologist",
  "Oral  Maxillofacial Surgeon",
  "Office Manager",
  "OMS Resident",
  "Oral Pathologist",
  "Orthodontist",
  "Orthodontic Resident",
  "Pediatric Dentist",
  "Pediatric Resident",
  "Periodontist",
  "Periodontic Resident",
  "Prosthodontist",
  "Public Health Dentist",
  "Radiologist",
  "Dental Lecturer",
  "TMD Specialist ",
  "Other",
];

export default specialties;



// WEBPACK FOOTER //
// ./src/constants/specialties.js